import { Result } from '../../../../../common/models/Result';
import { SearchOutput } from '../../../../../common/models/SearchOutput';
import { HttpServiceBase } from '../../../../../common/services/HttpServiceBase';
import { TransactionEventIdentificationEnum } from '../../../../enums/TransactionEventIdentificationEnum';
import { PointTransactionForHistory } from '../../../../models/PointTransactionForHistory';

export class GetMemberAccountPointsHistoryByShopifyCustomerIdService extends HttpServiceBase {

  handle = (shopifyCustomerId: number, memberAccountId: number, bearerToken: string): Promise<Result<GetMemberAccountPointsHistoryByShopifyCustomerIdOutput> | null> => {
    const promise = this.http.post<Result<GetMemberAccountPointsHistoryByShopifyCustomerIdOutput>, any>(
      `${this.baseUrlZerezesApi}/club-pdv/member-account-points-history/${shopifyCustomerId}`,
      {
        memberAccountId,
        transactionEventIds: [
          TransactionEventIdentificationEnum.PointsConverted,
          TransactionEventIdentificationEnum.RegisterAdditionalMemberAccountData,
          TransactionEventIdentificationEnum.LevelChangeReward,
          TransactionEventIdentificationEnum.CashConverted
        ],
        shouldPaginate: false,
        pageSize: 0,
        orderBy: 'TransactionDate',
        orderType: 0
      },
      false,
      bearerToken
    );
    return promise;
  }
}

export class GetMemberAccountPointsHistoryByShopifyCustomerIdOutput extends SearchOutput {
  list: PointTransactionForHistory[];
}